"use client";

import { useContext } from "react";
import { RootStoreContext } from "../context";
import type TilliXStore from "../../mobx/core/tillix";

/**
 * Client-only accessor for the TilliXStore. Returns `null` during SSR and
 * when the TilliXStore has not yet been initialized on the client.
 *
 * Prefer the `useHydrate*` hooks for read access to specific sub-stores — this
 * hook is an escape hatch for code paths that need to access TilliXStore
 * imperatively inside event handlers or effects.
 */
export function useTilliX(): TilliXStore | null {
  const root = useContext(RootStoreContext);
  if (!root) return null;
  if (!root.tilliXInitted) return null;
  return root.tilliX;
}
